import Vue from 'vue'
import {VueMaskFilter} from 'v-mask'

Vue.filter('VMask', VueMaskFilter)

export default Vue.component('auctioneer', {
  props: ['photo', 'auctioneer'],

  data() {
    return {}
  },

  created() {
    console.log(this.photo)
  },

  methods: {}
});
